import styled from "styled-components";
import Button from "@streeteasy/design-system/deprecated/Button";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";

import { smallScreen } from "../../../../shared/constants/screenSizes";

export const CTAContainer = styled.div`
  background-color: ${colors.frostedGlass};
  margin-top: 15px;
`;

export const CTAText = styled(Text).attrs({
  type: "sm"
})`
  @media screen and (max-width: ${smallScreen}px) {
    font-size: 16px;
  }
`;

export const ViewButton = styled(Button).attrs({
  height: "low",
  theme: "white"
})`
  margin-top: 10px;
  width: 100px;

  @media screen and (max-width: ${smallScreen}px) {
    height: 40px;
  }
`;
